import { EMPTY_ARRAY } from "../misc";
import { Category, getGraphicElementsFromGQResult, GraphicElement } from "../processors";
import { kpiReportTemplateDisplayController } from "./kpiReportTemplateDisplayController";
import { CategoryTemplateController } from "./types";
import _ from "lodash";

// check if this graphic element should be visible (fine grained check)
export const categoryDisplayControl = async (
    locationAdminIds: string[],
    categories: Category[],
    graphicElement: GraphicElement
): Promise<Category[]> => {
    if (!locationAdminIds || !locationAdminIds.filter(d => d != null && d.toString().trim() !== "").length)
        return EMPTY_ARRAY;

    const registeredController: Record<string, CategoryTemplateController> = {
        kpiReportTemplate: kpiReportTemplateDisplayController
    };

    if (!registeredController[graphicElement.type]) return categories;

    return registeredController[graphicElement.type](locationAdminIds, categories, graphicElement);
};

export const finaliseCategories = async (locationAdminIds: string[], categories: Category[]): Promise<Category[]> => {
    const categoriesWithContent = _.flattenDeep(
        categories?.map(category => {
            // console.log(category?.catGraphContent?.filter(d=>d?.kpiReportTemplate != null));
            const content = _.uniqBy(
                [
                    ...(category?.catGraphContent?.filter(d => d?.kpiReportTemplate != null) ?? [])
                    // ...(category?.catInfoContent ?? []),
                    // ...(category?.catTableContent ?? [])
                ],
                d => d.nid
            );

            return (
                content?.map(ge => {
                    return {
                        category,
                        element: ge
                    };
                }) ?? []
            );
        }) ?? []
    ).filter(d => d != null);

    const _content = _.uniqBy(categoriesWithContent?.map(d => d.element)?.filter(d => d != null) ?? [], d => d.nid);

    const nidToContent = _.keyBy(_content, d => d.nid);
    const nidToCategories = _.groupBy(categoriesWithContent, d => d.element.nid);

    const displayCategories = await Promise.all(
        _.keys(nidToContent ?? {})
            .filter(nid => {
                return nidToContent[nid] != null && nidToCategories[nid] != null;
            })
            .map(nid => {
                return categoryDisplayControl(
                    locationAdminIds,
                    nidToCategories[nid]?.map(d => d.category)?.filter(d => d != null) ?? [],
                    getGraphicElementsFromGQResult([nidToContent[nid]])[0]
                );
            })
    );

    return _.uniqBy(_.flattenDeep(displayCategories), d => d.tid);
};
